import { SWIPE } from '@/constants';
import React, { useState } from 'react';

function ModalSwipeCloseButton({ onClose, onTranslateY }) {
  const [startY, setStartY] = useState(null);

  // Handle Swipe Down Gesture on Mobile
  const handleTouchStart = (e) => {
    setStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e) => {
    e.preventDefault();

    if (!startY) return;
    const currentY = e.touches[0].clientY;
    const diff = currentY - startY;

    if (diff > 0) {
      onTranslateY(diff);
    }

    if (diff > 20) {
      onClose(SWIPE);
    }
  };

  const handleTouchEnd = () => {
    onTranslateY(0);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Slide down to close"
      className="modal-slide w-[65px] lg:hidden mx-auto border-b-4 border-himalayan-poppy rounded-[100px] mb-16 cursor-pointer"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    />
  );
}

export default ModalSwipeCloseButton;
